<template>
<Layout>
  <div class="row">
    <div class="col-md-12">
      <PageHeader :title="title" :items="items" />

      <b-card>
        <div class="row">
          <div class="col-md-12">
            <h4 class="text-center text-bold" style="text-transform:uppercase">Padma Bridge Rail Link Project - Phase 2(Bhanga to Jashore)</h4>
            <h5 class="text-center bold">Unpaid EP Count</h5>
          </div>
        </div>
        <div class="mb-1">
          <button type="button" id="export-table" @click="onexport"  class="btn btn-success float-right mb-1" style="margin-bottom:5px">Download Excel</button>
        </div>

        <div class="table-responsive" style="overflow-x: auto">
          <table class="table table-centered table-striped" id="titledExcel">
            <thead>
            <tr>
              <th>Sl</th>
              <th>District</th>
              <th>Total EP</th>
              <th>Unpaid Amount</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(unpaid_ep_count, index) in unpaid_ep_counts" :key="index">
              <td>{{ index + 1 }}</td>
              <td>{{ unpaid_ep_count.district_desc }}</td>
              <td>{{ unpaid_ep_count.total_eps }}</td>
              <td>{{ parseFloat(unpaid_ep_count.total_amount).toFixed(2) }}</td>
            </tr>
            </tbody>
            <tfoot>
            <tr>
              <td></td>
              <td class="font-weight-bold">Total</td>
              <td class="font-weight-bold">{{ total_district_info.total_eps }}</td>
              <td class="font-weight-bold">{{ total_district_info.total_amount }}</td>
            </tr>
            </tfoot>
          </table>
          <div v-if="loader" class="loader">Loading...</div>
        </div>
      </b-card>
    </div>
  </div>
</Layout>
</template>

<script>
import appConfig from "@src/app.config.json";
import Layout from "@layouts/main";
import PageHeader from "@components/page-header";
import http from "@state/http";
import XLSX from 'xlsx';

export default {
  page: {
    title: "List of CCL",
    meta: [{name: "description", content: appConfig.description}]
  },
  components: {Layout, PageHeader},
  data() {
    return {
      title: "Count Unpaid EP",
      items: [
        {
          text: "Dashboard",
          href: "/"
        },
        {
          text: "Count Unpaid EP",
          active: true
        }
      ],
      flag: false,
      loader: false,
      unpaid_ep_counts: {},
      total_district_info: {},
    };
  },

  mounted() {
    this.search();
  },
  methods: {
    search() {
      this.flag = true
      this.loader = true
      http.get("api/unpaid/ep/count").then(response => {
        if (!response.error) {
          this.flag = true;
          this.loader = false
          this.unpaid_ep_counts = response.data.unpaid_ep_counts;
          this.total_district_info = response.data.total_district_info;
        }
      });
    },
    onexport(evt) {
      var tbl = document.getElementById('titledExcel');
      var wb = XLSX.utils.table_to_book(tbl);
      XLSX.writeFile(wb, "unpaid-ep-count.xlsx");
    }
  },
  computed: {
    userPermission () {
      return this.$store.state.user
    },
  },
  created () {
    this.$store.dispatch('getUserPermission')
  },
};
</script>

<style scoped>

</style>
